import React, { useState, forwardRef, useEffect } from 'react';
import { connect } from 'react-redux';
import classes from "./form.module.css";
import { sixYardAxios } from "../../../sixYardAxios";
import InputField from "../../containers/inputField/inputField";
import Title from "../../containers/title/title";
import PromptMessage from "../../containers/promptMessage/promptMessage";

const Form = forwardRef((props, ref) => {
    const [isTermsChecked, setIsTermsChecked] = useState(false);
    const [services, setServices] = useState([]);
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);
    
    // Use Redux for language management
    const isEnglish = props.selectedLanguage === 1;
    
    const [tournamentControls, setTournamentControls] = useState({
        tournamentName: {
            elementType: "input",
            elementConfig: {
                type: "text",
                placeholder: isEnglish ? "Enter name" : "أدخل الاسم",
            },
            value: "",
            validation: {
                required: true,
            },
            label: isEnglish ? "Tournament Name" : "اسم البطولة",
            valid: false,
            touched: false
        },
        numberOfTeams: {
            elementType: "input",
            elementConfig: {
                type: "number",
                placeholder: isEnglish ? "Enter number" : "أدخل العدد",
            },
            value: "",
            validation: {
                required: true,
                isNumeric: true
            },
            label: isEnglish ? "Number Of Teams" : "عدد الفرق",
            valid: false,
            touched: false
        },
        tournamentDates: {
            withIcon: true,
            withRemove: true,
            elementType: "input",
            elementConfig: {
                type: "calendarDate",
                placeholder: isEnglish ? "Select date" : "اختر التاريخ",
            },
            value: "",
            validation: {
                required: true,
            },
            label: isEnglish ? "Tournament Date/s" : "تواريخ البطولة",
            valid: false,
            touched: false,
            isMultiple: true,
        },
    });
    const [controls, setControls] = useState({
        yourName: {
            elementType: "input",
            elementConfig: {
                type: "text",
                placeholder: isEnglish ? "Enter name" : "أدخل الاسم",
            },
            value: "",
            validation: {
                required: true,
            },
            label: isEnglish ? "Your Name" : "اسمك",
            valid: false,
            touched: false
        },
        corporationName: {
            elementType: "input",
            elementConfig: {
                type: "text",
                placeholder: isEnglish ? "Enter name" : "أدخل الاسم",
            },
            value: "",
            label: isEnglish ? "Corporation Name" : "اسم المؤسسة",
            valid: false,
            touched: false
        },
        email: {
            elementType: "input",
            elementConfig: {
                type: "email",
                placeholder: isEnglish ? "Enter email" : "أدخل البريد الإلكتروني",
            },
            value: "",
            label: isEnglish ? "Email" : "البريد الإلكتروني",
            validation: {
                required: true,
                isEmail: true
            },
            valid: false,
            touched: false
        },
        phone: {
            elementType: "input",
            elementConfig: {
                type: "phone",
                placeholder: "07xxxxxxxx",
                options: []
            },
            value: "",
            valueName: "phone_number",
            validation: {
                required: true,
                isNumeric: true
            },
            label: isEnglish ? "Phone" : "رقم الهاتف",
            valid: false,
            touched: false
        },
        tournamentDetails: {
            elementType: "textarea",
            elementConfig: {
                type: "textarea",
                placeholder: isEnglish 
                    ? "Enter your requests in details" 
                    : "أدخل طلباتك بالتفصيل",
            },
            value: "",
            label: isEnglish ? "Tournament Details" : "تفاصيل البطولة",
            valid: false,
            touched: false,
        },
    });
    
    // Add effect to update form controls when language changes
    useEffect(() => {
        updateFormLanguage();
    }, [props.selectedLanguage]);
    
    const updateFormLanguage = () => {
        // Update tournament controls
        setTournamentControls(prevState => {
            const updated = { ...prevState };
            updated.tournamentName = {
                ...updated.tournamentName,
                elementConfig: {
                    ...updated.tournamentName.elementConfig,
                    placeholder: isEnglish ? "Enter name" : "أدخل الاسم"
                },
                label: isEnglish ? "Tournament Name" : "اسم البطولة"
            };
            updated.numberOfTeams = {
                ...updated.numberOfTeams,
                elementConfig: {
                    ...updated.numberOfTeams.elementConfig,
                    placeholder: isEnglish ? "Enter number" : "أدخل العدد"
                },
                label: isEnglish ? "Number Of Teams" : "عدد الفرق"
            };
            updated.tournamentDates = {
                ...updated.tournamentDates,
                elementConfig: {
                    ...updated.tournamentDates.elementConfig,
                    placeholder: isEnglish ? "Select date" : "اختر التاريخ"
                },
                label: isEnglish ? "Tournament Date/s" : "تواريخ البطولة"
            };
            return updated;
        });
        
        // Update contacts controls
        setControls(prevState => {
            const updated = { ...prevState };
            updated.yourName = {
                ...updated.yourName,
                elementConfig: {
                    ...updated.yourName.elementConfig,
                    placeholder: isEnglish ? "Enter name" : "أدخل الاسم"
                },
                label: isEnglish ? "Your Name" : "اسمك"
            };
            updated.corporationName = {
                ...updated.corporationName,
                elementConfig: {
                    ...updated.corporationName.elementConfig,
                    placeholder: isEnglish ? "Enter name" : "أدخل الاسم"
                },
                label: isEnglish ? "Corporation Name" : "اسم المؤسسة"
            };
            updated.email = {
                ...updated.email,
                elementConfig: {
                    ...updated.email.elementConfig,
                    placeholder: isEnglish ? "Enter email" : "أدخل البريد الإلكتروني"
                },
                label: isEnglish ? "Email" : "البريد الإلكتروني"
            };
            updated.phone = {
                ...updated.phone,
                label: isEnglish ? "Phone" : "رقم الهاتف"
            };
            updated.tournamentDetails = {
                ...updated.tournamentDetails,
                elementConfig: {
                    ...updated.tournamentDetails.elementConfig,
                    placeholder: isEnglish ? "Enter your requests in details" : "أدخل طلباتك بالتفصيل"
                },
                label: isEnglish ? "Tournament Details" : "تفاصيل البطولة"
            };
            return updated;
        });
    };
    
    const formElementsArray = [];
    for (let key in controls) {
        formElementsArray.push({
            id: key,
            config: controls[key]
        });
    }
    const form = formElementsArray.map((formElement, i) => (
        <div key={i} className={[classes.FormGroup, formElement.id === "tournamentDates" && classes.FormGroupCalendar].join(" ")}>
            <InputField
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                touched={formElement.config.touched}
                withRemove={false}
                withIcon={formElement.config.withIcon}
                label={formElement.config.label}
                changed={event => inputChangedHandler(event, formElement.id, setControls, controls)}
            />
        </div>
    ));
    const tournamentFormElementsArray = [];
    for (let key in tournamentControls) {
        tournamentFormElementsArray.push({
            id: key,
            config: tournamentControls[key]
        });
    }
    const tournamentForm = tournamentFormElementsArray.map((formElement, i) => (
        <div key={i} className={classes.FormGroup}>
            <InputField
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                touched={formElement.config.touched}
                withRemove={false}
                withIcon={formElement.config.withIcon}
                label={formElement.config.label}
                isMultiple={formElement.config.isMultiple}
                changed={event => inputChangedHandler(event, formElement.id, setTournamentControls, tournamentControls)}
            />
        </div>
    ));
    const checkValidity = ((value, rules) => {
        let isValid = true;
        if (!rules) {
            return true;
        }

        if (rules.required) {
            value = typeof value === 'string' ? value.trim() : value;
            isValid = value !== "" && isValid;
        }

        if (rules.isEmail) {
            const pattern = /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/;
            isValid = pattern.test(value) && isValid;
        }

        if (rules.isNumeric) {
            const pattern = /^\d+$/;
            isValid = pattern.test(value) && isValid;
        }

        return isValid;
    })
    const inputChangedHandler = (event, controlName, controlFunction, state) => {
        const value = (controlName === 'phone' || controlName === 'tournamentDates') ? event : event.target.value;
        const updatedControls = {
            ...state,
            [controlName]: {
                ...state[controlName],
                value,
                valid: checkValidity(value, state[controlName].validation),
                touched: true
            }
        };
        controlFunction(updatedControls);
    };

    const submitHandler = e => {
        e.preventDefault();
        if (!props.isAuthenticated) props.setShowLoginForm(true)
        else {
            const formData = {
                tournament_name: tournamentControls.tournamentName.value,
                number_of_teams: tournamentControls.numberOfTeams.value,
                tournament_dates: tournamentControls.tournamentDates.value,
                services: services,
                contact_details: {
                    name: controls.yourName.value,
                    email: controls.email.value,
                    phone: controls.phone.value.dialCode + controls.phone.value.number,
                    corporation_name: controls.corporationName.value
                },
                additional_details: controls.tournamentDetails.value,
                terms_accepted: isTermsChecked,
                lang: props.selectedLanguage // Add language parameter to API request
            }
            sixYardAxios({
                method: "post",
                url: "/tournaments/create-custom",
                data: formData
            })
                .then(response => {
                    localStorage.setItem("CustomTournament", JSON.stringify(formData));
                    clearControls();
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                    props.setTournamentId(response.data.data.tournament_id);
                    props.setDates(response.data.data.tournament_dates);
                    props.setLoyaltyPoints(response.data.data.calculations?.loyalty_points);
                    props.setAmount(response.data.data.calculations?.total_amount);
                    props.setSelectedServices(response.data.data.calculations?.services);
                    setSuccess(response.data.data.message);
                    // props.setShowCheckout(true);
                })
                .catch(error => {
                    setError(error.response.data.message);
                });
        }
    };
    const clearControls = () => {
        const updatedControls = {
            ...controls
        };
        for (let key in controls) {
            updatedControls[key] = {
                ...controls[key],
                value: "",
                valid: false,
                touched: false
            };
        }
        setControls(updatedControls);
    };
    const handleCheckboxChange = (id) => {
        setServices((prevServices) => {
            if (prevServices.includes(id)) {
                return prevServices.filter((serviceId) => serviceId !== id);
            } else {
                return [...prevServices, id];
            }
        });
    };
    const successClicked = () => {
        setSuccess(false);
        window.location.reload();
    }
    return (
        <div className={classes.Container} ref={ref}>
            <Title title={isEnglish ? 'CREATE TOURNAMENT' : 'إنشاء بطولة'} />
            <form className={classes.FormContainer} onSubmit={(e) => submitHandler(e)}>
                <div className={classes.StepTitle}>
                    {isEnglish ? "Step 1: Tournament Details" : "الخطوة ١: تفاصيل البطولة"}
                </div>
                {tournamentForm}
                <div>
                    <div className={classes.StepTitle}>
                        {isEnglish 
                            ? "Step 2: Extra Services Provided By Us" 
                            : "الخطوة ٢: الخدمات الإضافية المقدمة من قبلنا"}
                    </div>
                    <div className={classes.Info}>
                        {isEnglish 
                            ? "Select services you want to add" 
                            : "اختر الخدمات التي تريد إضافتها"}
                    </div>
                    <div>{props.services?.map(item =>
                        <div className={classes.CheckBox} key={item.id}>
                            <input type="checkbox"
                                onChange={() => handleCheckboxChange(item.id)}
                                checked={services.includes(item.id)} />
                            <label className={classes.Label}>
                                {item.name}
                            </label>
                        </div>
                    )}</div>
                </div>
                <div className={classes.StepTitle}>
                    {isEnglish ? "Step 3: Your Details" : "الخطوة ٣: تفاصيلك"}
                </div>
                {form}
                <p className={classes.Prompt}>
                    {isEnglish 
                        ? "Please read and agree to our "
                        : "يرجى قراءة والموافقة على "}
                    <a href="/privacy-policy" target='_blank' className={classes.Link}>
                        {isEnglish 
                            ? "Privacy Policy "
                            : "سياسة الخصوصية "}
                    </a>
                    {isEnglish ? "and " : "و "}
                    <a href="/terms-and-conditions" target='_blank' className={classes.Link}>
                        {isEnglish ? "Terms" : "الشروط"}
                    </a>
                </p>
                <div className={classes.CheckBox}>
                    <input type="checkbox" onClick={() => setIsTermsChecked(!isTermsChecked)} />
                    <label className={classes.Label}>
                        {isEnglish 
                            ? "I have read and agreed to terms and conditions and privacy policy"
                            : "لقد قرأت ووافقت على الشروط والأحكام وسياسة الخصوصية"}
                    </label>
                </div>
                <div>
                    <button type="submit" 
                        className={[classes.submitButton, !isTermsChecked && classes.Disabled].join(" ")}
                        disabled={!isTermsChecked}
                    >
                        {isEnglish ? "SUBMIT" : "إرسال"}
                        <img
                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/b4d5bcaf1ebb966f9c466b88bc4db272a664766c03afdc1eeb10bad706c68a4a?placeholderIfAbsent=true&apiKey=55c20a0273674f7297318d8ed49e9ee9"
                            alt=""
                            className={classes.submitIcon}
                        />
                    </button>
                </div>
            </form>
            {error && <PromptMessage 
                message={error} 
                status={isEnglish ? 'Oops' : 'عفواً'} 
                button={isEnglish ? 'CLOSE' : 'إغلاق'} 
                click={() => setError(false)} 
            />}
            {success && <PromptMessage 
                message={success} 
                status={isEnglish ? 'CONGRATULATIONS' : 'تهانينا'} 
                successMessage 
                button={isEnglish ? 'CLOSE' : 'إغلاق'} 
                click={successClicked} 
            />}
        </div>
    )
});

const mapStateToProps = state => ({
    selectedLanguage: state.home.selected_language
});

export default connect(mapStateToProps)(Form);